const mediaMatch = {
  matcher:
    /(youtube\.com|youtu\.be|youtube-nocookie\.com)\/(watch\?v=|v\/|u\/|embed\/?)?(videoseries\?list=(.*)|[\w-]{11}|\?listType=(.*)&list=(.*)).*/i,
  url: 'https://www.youtube.com/embed/$3',
};

export default { mediaMatch };
